import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../images/Logo.png';
import CodingSuccessfully from '../images/coding-successfully.PNG';
import SinanSoft from '../images/Sinansoft.JPG';
import DaniImage from '../images/Dani.jpeg';
import JeissonImage from '../images/Jeisson.jpeg';
import SaeidImage from '../images/Saied.jpeg';
import '../styles/template.css';

const PartnersPage = () => {
  return (
    <div className="container">
      <header>
        <div className="logo-container">
          <img src={Logo} alt="Logo" className="logo" />
        </div>
        <h1>Partners</h1>
        <nav>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/partners">Partners</Link></li>
            <li><Link to="/elevate">Elevate</Link></li>
            <li><Link to="/connect">Connect</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </nav>
      </header>

      <main>
        <h2 className="main-heading">Our Partners</h2>
        
        <section className="partners-intro">
          <p>
            We're proud to work with amazing organizations and people who share our mission 
            of helping people discover themselves and connect with authentic experiences that inspire growth and self-discovery.
          </p>
        </section>

        <section className="partners-grid">
          {/* Strategic Partners */}
          <div className="partner-category">
            <h3>Strategic Partners</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner">
                <div className="partner-logo">
                  <img src={CodingSuccessfully} alt="Coding Successfully Logo" />
                </div>
                <div className="partner-info">
                  <h4>Coding Successfully</h4>
                  <p>
                    Coding Successfully is proud to be a creative and strategic partner in making the Know Yourself vision a reality. 
                    With expertise in digital strategy, marketing, and technology, they help amplify the impact of our platform 
                    and create real-world connections that foster growth, community, and well-being.
                  </p>
                  <a href="https://codingsuccessfully.com" target="_blank" rel="noopener noreferrer" className="partner-link">Visit Website</a>
                </div>
              </div>
            </div>
          </div>

          {/* Technology Partners */}
          <div className="partner-category">
            <h3>Technology Partners</h3>
            <div className="partner-cards">
              <div className="partner-card featured-partner">
                <div className="partner-logo">
                  <img src={SinanSoft} alt="SinanSoft Logo" />
                </div>
                <div className="partner-info">
                  <h4>SinanSoft Inc.</h4>
                  <p>
                    SinanSoft is a Los Angeles-based software development company specializing in complex distributed enterprise 
                    applications and high-traffic portal development. Their team of skilled engineers and project managers ensures our 
                    technology infrastructure can grow with our community.
                  </p>
                  <div className="partner-credentials">
                    <strong>Notable Clients:</strong> University of California Irvine, Centralive, ODTech, Dentirate
                  </div>
                  <a href="https://sinansoft.com/" target="_blank" rel="noopener noreferrer" className="partner-link">Visit Website</a>
                </div>
              </div>
            </div>
          </div>

          {/* Team Partners */}
          <div className="partner-category">
            <h3>Key Contributors</h3>
            <div className="partner-cards">
              <div className="partner-card">
                <div className="partner-profile">
                  <img src={SaeidImage} alt="Dr. Saeid Makhmali" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Dr. Saeid Makhmali – Founder & CEO of SinanSoft Inc.</h4>
                  <p>
                    Dr. Makhmali brings exceptional technical leadership to the Know Yourself project with his extensive background 
                    in enterprise software development. Having served in senior roles at Apple, UBS Investment Bank, and Luxoft, 
                    he provides invaluable guidance on scaling our platform architecture and ensuring robust, enterprise-grade 
                    solutions that can support our growing community of users seeking authentic self-discovery experiences.
                  </p>
                </div>
              </div>

              <div className="partner-card">
                <div className="partner-profile">
                  <img src={JeissonImage} alt="Jeisson Rueda" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Jeisson Rueda – Founder/CEO of Coding Successfully</h4>
                  <p>
                    Jeisson and Grant connected through a shared vision of empowering people to live with greater authenticity and purpose. 
                    With Coding Successfully, Jeisson brings expertise in digital strategy, marketing, and technology to amplify the impact 
                    of the Know Yourself project. Together, we are building a platform that not only inspires people to discover their unique 
                    intelligence, but also creates real-world connections and experiences that foster growth, community, and well-being.
                  </p>
                </div>
              </div>
              
              <div className="partner-card">
                <div className="partner-profile">
                  <img src={DaniImage} alt="Daniela Medina" className="profile-image" />
                </div>
                <div className="partner-info">
                  <h4>Daniela Medina – Consultant & Strategist at Coding Successfully</h4>
                  <p>
                    Daniela shares the Know Yourself vision of helping people connect with authentic experiences that inspire growth and self-discovery. 
                    With a strong background in strategy and creative direction, she has contributed to shaping the content vision and storytelling 
                    behind the project. Daniela's insight and passion for meaningful communication continue to guide the way Know Yourself engages 
                    with its community and builds a platform that truly resonates with people's lives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Partnership Opportunities */}
        <section className="partnership-cta">
          <h3>Interested in Partnering with Us?</h3>
          <p>
            We're always looking for organizations that share our values and want to help 
            people discover themselves and connect with their communities.
          </p>
          <Link to="/contact" className="cta-button">Get in Touch</Link>
        </section>
      </main>

      <footer>
        <p>&copy; 2025 Know Yourself LLC | All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PartnersPage;
